import CustomToggle from "./CustomToggle";

const FieldSettingsGroup = ({
  fieldValues,
  setFieldValues,
  showModificationProtection,
}) => {
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setFieldValues((prev) => ({ ...prev, [name]: checked }));
  };

  return (
    <>
      <CustomToggle
        title="Required Field"
        description="Choosing Yes makes this field required inside of the CRM
                  instance when new data is added."
        stateName="required"
        value={fieldValues.required}
        handleChange={handleCheckboxChange}
        disabled={fieldValues.protected && !showModificationProtection}
      />
      <CustomToggle
        title="Unique Field"
        description="Choosing Yes makes this field Unique inside of the CRM
                  instance when new data is added."
        stateName="unique"
        value={fieldValues.unique}
        handleChange={handleCheckboxChange}
        disabled={fieldValues.protected && !showModificationProtection}
      />
      <CustomToggle
        title="Read Only Field"
        description="Choosing Yes makes this field read only. A read only field cannot be updated after creation."
        stateName="readonly"
        value={fieldValues.readonly}
        handleChange={handleCheckboxChange}
        disabled={fieldValues.protected && !showModificationProtection}
      />
      <CustomToggle
        title="Sensitive Field"
        description="Sensitive Fields are encrypted at the field-level within each record for more secure storage. As a result, they cannot be used with searching and filtering."
        stateName="sensitive"
        value={fieldValues.sensitive}
        handleChange={handleCheckboxChange}
        disabled={fieldValues.protected && !showModificationProtection}
      />
      {showModificationProtection && (
        <>
          <CustomToggle
            title="Modification Protection"
            description="Choosing Yes prevents a Cloud Administrator from modifying
                    or deleting the field inside their CRM instance."
            stateName="protected"
            value={fieldValues.protected}
            handleChange={handleCheckboxChange}
            disabled={fieldValues.protected && !showModificationProtection}
          />
          <CustomToggle
            title="Rename Modification Protection"
            description="Choosing Yes prevents a Cloud Administrator from renaming 
                    the field inside their CRM instance."
            stateName="renameProtected"
            value={fieldValues.renameProtected}
            handleChange={handleCheckboxChange}
            disabled={fieldValues.protected && !showModificationProtection}
          />
        </>
      )}
    </>
  );
};

export default FieldSettingsGroup;
